export default __webpack_public_path__ + "static/media/link.40fd9357.svg";